import type { RiskLevels } from 'src/library/lists/riskLevels';
import type { ListItemIcon } from 'src/library/lists/listItemIcon';
import { suggestionEntityTypes } from 'src/store/selectors/suggestion-entity-types';

export function getListSectionMainIcon(
  type: string,
  unchangedTemplate: boolean | undefined,
  classification: string | undefined,
  riskAssessmentRisk: RiskLevels | undefined = undefined,
  competenceStatus: string | undefined = undefined,
): ListItemIcon | undefined {
  if (classification !== undefined && classification !== 'NONE') {
    return 'lock';
  }
  if (suggestionEntityTypes.includes(type) && unchangedTemplate) {
    return 'suggestion';
  }
  if (type === 'riskAssessments') {
    if (riskAssessmentRisk) {
      return ('risk' + riskAssessmentRisk) as ListItemIcon;
    }
    return 'risk0';
  }
  if (type === 'competence') {
    if (competenceStatus === 'EXPIRED') {
      return 'alert';
    }
    if (competenceStatus === 'EXPIRING_SOON') {
      return 'xOrange';
    }
    return 'checkBlue';
  }
}
